import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-770ef5ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fymusic" }
const _hoisted_2 = {
  key: 0,
  class: "icon i-bofangzanting"
}
const _hoisted_3 = {
  key: 1,
  class: "icon i-bofang"
}
const _hoisted_4 = { class: "fymusic-content" }
const _hoisted_5 = { class: "title c-primary" }
const _hoisted_6 = { class: "actor c-thirdary" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "times c-thirdary" }
const _hoisted_10 = ["src"]

import api from '@/api/fyApi';
import * as filters from '@/views/filters';
import ViewContext from '@/views/ViewContext';
import { computed, inject, onMounted, reactive, ref, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  props: {
    dataTitle: null,
    dataActor: null,
    dataUrl: null,
    dataMovid: null,
    dataUrlid: null
  },
  setup(__props: any) {

const props = __props as {
    dataTitle: string,
    dataActor: string,
    dataUrl: string,
    dataMovid: string,
    dataUrlid: string
}

const context = inject('context') as ViewContext

const state = reactive({
    current: 0,
    duration: 0,
    playing: false,
    drag: false,
    url: ''
})
const progress = computed(() => state.current / state.duration)
const audio = ref<HTMLAudioElement>()
const url = computed(() => {
    if (props.dataUrl) {
        if (props.dataUrl.indexOf("://") > 0) {
            return props.dataUrl
        } else {
            return `//yuedu-api.sanmanuela.net/v1/tools/getaudio?mediaid=` + props.dataUrl
        }
    } else {
        return state.url
    }
})
watch(() => props.dataUrlid, checkUrl)
onMounted(checkUrl)
async function checkUrl() {
    if (props.dataMovid && props.dataUrlid) {
        let r = await api.getMovieResourceUrl(props.dataMovid, props.dataUrlid, 3)
        state.url = r.url
        state.duration = 0
        state.current = 0
    }
}
function doPlay() {
    if (audio.value) {
        if (state.playing) {
            audio.value.pause()
        } else {
            audio.value.play()
            context.registerMedia(doStop)
        }
    }
}

function doStop() {
    if (audio.value) {
        audio.value.pause()
    }
}

function onLoad() {
    if (audio.value) {
        state.duration = audio.value.duration
    }
}
function onTimeUpdate() {
    if (audio.value && !state.drag) {
        state.current = audio.value.currentTime
    }
}
function onPlay() {
    state.playing = true
}
function onPause() {
    state.playing = false
}
function onEnd() {
    state.playing = false
}
function onProgressChange(e: MouseEvent) {
    if (audio.value && state.duration > 0) {
        audio.value.currentTime = state.current = state.duration * e.offsetX / 465
        audio.value.play()
    }
}
function onMouseDown(e: MouseEvent) {
    if (audio.value && state.duration > 0) {
        state.drag = true
        let x = e.pageX
        let c = state.current
        document.onmousemove = function (e: MouseEvent) {
            state.current = Math.floor(c + state.duration * (e.pageX - x) / 465)
        }
        document.onmouseup = function () {
            document.onmouseup = null
            document.onmousemove = null
            if (audio.value) {
                audio.value.currentTime = Math.floor(state.current)
            }
            state.drag = false
        }
    }

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "poster",
      onClick: doPlay
    }, [
      (_unref(state).playing)
        ? (_openBlock(), _createElementBlock("i", _hoisted_2))
        : (_openBlock(), _createElementBlock("i", _hoisted_3))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.dataTitle), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.dataActor), 1),
      _createElementVNode("div", {
        class: "progress",
        onClick: onProgressChange
      }, [
        _createElementVNode("div", {
          class: "track",
          style: _normalizeStyle({ width: _unref(progress) * 100 + '%' })
        }, [
          _createElementVNode("a", {
            class: "thumb",
            onMousedown: onMouseDown
          }, _hoisted_8, 32)
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", null, _toDisplayString(_unref(filters).leftTime(_unref(state).current)), 1),
        _createElementVNode("span", null, _toDisplayString(_unref(filters).leftTime(_unref(state).duration)), 1)
      ])
    ]),
    _createElementVNode("audio", {
      ref_key: "audio",
      ref: audio,
      src: _unref(url),
      onPlay: onPlay,
      onPause: onPause,
      onEnded: onEnd,
      onLoadedmetadata: onLoad,
      onTimeupdate: onTimeUpdate
    }, null, 40, _hoisted_10)
  ]))
}
}

})